import { HttpStatusCodes } from '@zocdoc/components/src/constants';
import { userEndpoint } from './constants';

export async function fetchUser() {
    const resp = await fetch(userEndpoint, {
        // Pass session cookie
        credentials: 'include',
    });
    if (resp.status === HttpStatusCodes.OK) {
        const user = await resp.json();
        return {
            displayName: user.display_name,
            loginState: user.login_state,
        };
    } else {
        throw new Error(`User API returned unexpected status code: ${resp.status}`);
    }
}
